import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserActivityComponent } from './user-activity.component';
import { UserTrainingActivityDetailsModalComponent } from '../user-training-activity-details-modal/user-training-activity-details-modal.component';
import { SharedModule } from '@shared/shared.module';

/**
 * Standalone UserActivityModule
 * Can be imported into any module without routing conflicts
 */
@NgModule({
    declarations: [
        UserActivityComponent,
        UserTrainingActivityDetailsModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule
    ],
    exports: [
        UserActivityComponent,
        UserTrainingActivityDetailsModalComponent
    ]
})

export class UserActivityModule { }

